import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { Avanzamento } from "@/types/api";

export function useAvanzamento() {
  return useQuery({
    queryKey: ["avanzamento"],
    queryFn: () => apiFetch<Avanzamento>("/api/v1/avanzamento"),
    staleTime: 60_000,
  });
}
